<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box"
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      v-if="manageType==='edit'"
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["496"]') }}<span class=" ml-16"> <a-tag color="#ebebeb">{{ projectItemData.projectname }}</a-tag></span></h2>
      <div class="d-tip-con">
        {{ eidtProTip[0] }}<br>{{ $t('message["1092"]') }}{{ eidtProTip[1] }}？
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="triggerEdit"
        >
          {{ $t('message["466"]') }}
        </a-button>
        <a-button
          class="ml-16"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
    <div
      v-if="manageType==='close'"
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["486"]') }} <span><a-tag color="#ebebeb">{{ projectItemData.projectname }}</a-tag></span></h2>
      <div class="d-tip-con">
        {{ closeProTip[0] }}<br>{{ closeProTip[1] }}？
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          :disabled="submiting"
          @click="closeProject"
        >
          {{ $t('message["466"]') }}
        </a-button>
        <a-button
          class="ml-16"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions } from 'vuex'
import { getStorage } from '@/lib/storage'

export default {
  props: {
    manageType: {
      type: String,
      default: ''
    },
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    tabType () {
      const { type } = this.$route.query
      return type
    },
    cId () {
      return this.projectItemData.cid
    },
    projectId () {
      return this.projectItemData.projectid
    },
    closeProTip () {
      return this.$t('message["406"]').split('|')
    },
    eidtProTip () {
      return this.$t('message["1399"]').split('|')
    }
  },
  methods: {
    ...mapActions('organization/org', ['ajaxClosePro', 'fetchProjectList']),
    ...mapActions('organization/orgRealback', ['ajaxCloseProRealback']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    async closeProject () {
      this.submiting = true
      let chain = null
      if (this.tabType === 'realback') {
        const realbackCid = getStorage('realbackCid')
        chain = await this.ajaxCloseProRealback({
          cid2: this.cId,
          cid: realbackCid,
          projectid: this.projectId
        })
        chain.onSuccess(async () => {
          const chain2 = await this.fetchProjectList({ cid: this.cId })
          chain2.fetch()
        })
      } else {
        chain = await this.ajaxClosePro({ cid: this.cId })
        chain
          .params({
            cid: this.cId,
            projectid: this.projectId,
            pType: this.$route.query.type === 'member' ? 2 : 1
          })
          .onNetSuccess(() => {
            this.TipDialogVisible = false
            this.submiting = false
          })
          .fetch()
      }
    },
    triggerEdit () {
      this.$emit('triggerMethod')
      this.TipDialogVisible = false
    }
  }
}
</script>
